/* DietXP Breast Cancer Support Group page (migration/breast-cancer-support-group-2026-11-04). Built into
   assets/dxp-support-group.js by tools/build.py from src/sg.js.
   1. Page motion: adds .dxsg--motion (none with reduced motion) and reveals .dxsg-rv items once as they come on screen.
   2. Step players ("How it works", "Inside a session"): ported from the CAM article player (owner rule, 1 Nov 2026).
      They play by themselves once when half the steps are on screen; each step stays 3 s plus 0.2 s a word (at least 5 s)
      with a timer line; they stop off screen and in a hidden tab; one Pause / Replay / Play button; any Back or Next press
      hands control to the reader for good; steps are read out only after the reader takes control; with reduced motion
      nothing plays by itself. Without JavaScript every step shows as a list.
   3. Join form: not a <form> element on purpose, so GTM, Google and Meta see no form submit and no field values
      (owner, 4 Nov 2026). Values go only to api.dietxp.com by fetch, never into the URL or the dataLayer.
      While data-open is "false" (backend off) it checks the answers, sends nothing and says so. */
(function () {
  var root = document.getElementById('dxsg');
  if (!root) return;
  var T = {};
  try { T = JSON.parse(document.getElementById('dxsg-text').textContent); } catch (e) {}
  /* words come from the page's text JSON (English or Hindi page); d is the English fallback */
  function txt(k, map, d) { var s = T[k] || d || ''; if (map) for (var key in map) s = s.split('{' + key + '}').join(map[key]); return s; }

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduce = !mq || mq.matches, autos = [];
  if (mq) {
    var onPref = function () {
      reduce = mq.matches;
      root.classList.toggle('dxsg--motion', !reduce);
      for (var a = 0; a < autos.length; a++) autos[a]();
    };
    if (mq.addEventListener) mq.addEventListener('change', onPref); else if (mq.addListener) mq.addListener(onPref);
  }

  /* 1. entrances: pre-hide only what is below the fold, so nothing on the first screen blinks */
  if (!reduce && 'IntersectionObserver' in window) {
    root.classList.add('dxsg--motion');
    var rv = root.querySelectorAll('.dxsg-rv'), vh = window.innerHeight || 800;
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        if (!es[i].isIntersecting) continue;
        es[i].target.classList.remove('is-wait');
        es[i].target.classList.add('is-in');
        io.unobserve(es[i].target);
      }
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    for (var r = 0; r < rv.length; r++) {
      var rect = rv[r].getBoundingClientRect();
      if (rect.top < vh * 0.92) { rv[r].classList.add('is-in'); continue; }
      rv[r].classList.add('is-wait');
      io.observe(rv[r]);
    }
  } else {
    var all = root.querySelectorAll('.dxsg-rv');
    for (var q = 0; q < all.length; q++) all[q].classList.add('is-in');
  }

  /* 2. step players */
  var mods = root.querySelectorAll('.dxsg-mod[data-sg-steps]');
  for (var m = 0; m < mods.length; m++) { steps(mods[m]); mods[m].classList.add('dxsg-js'); }

  function steps(mod) {
    var n = +mod.getAttribute('data-sg-steps');
    var items = mod.querySelectorAll('.dxsg-step');
    var prev = mod.querySelector('[data-sg-prev]'), next = mod.querySelector('[data-sg-next]'), play = mod.querySelector('[data-sg-play]');
    var status = mod.querySelector('.dxsg-status'), list = mod.querySelector('.dxsg-steps');
    var now = 1, timer = null, held = false, done = false, onScreen = false, told = false, mine = false;
    var bar = document.createElement('span');
    bar.className = 'dxsg-timer'; bar.setAttribute('aria-hidden', 'true'); bar.appendChild(document.createElement('span'));
    mod.querySelector('.dxsg-ctrl').appendChild(bar);
    /* time counts the step's own words, not the words in its picture */
    function wait(k) { return Math.max(5000, 3000 + items[k - 1].querySelector('.dxsg-step__text').textContent.trim().split(/\s+/).length * 200); }
    function show(k) {
      now = k;
      for (var i = 1; i <= n; i++) mod.classList.toggle('sg-s' + i, i <= k);
      mod.setAttribute('data-now', k);
      for (var j = 0; j < items.length; j++) {
        var on = +items[j].getAttribute('data-s') === k;
        items[j].classList.toggle('is-on', on);
        items[j].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      prev.setAttribute('aria-disabled', k === 1 ? 'true' : 'false');
      next.textContent = k === n ? txt('again', null, 'Start again') : txt('next', null, 'Next step');
      label();
      status.innerHTML = '';
      var c = document.createElement('span');
      c.textContent = done && k === n ? txt('finished', { n: n }, 'Finished: step {n} of {n}. Use Replay to watch again.') : txt('stepOf', { k: k, n: n }, 'Step {k} of {n}');
      status.appendChild(c);
      if (told) {
        var t = document.createElement('span');
        t.className = 'dxsg-vh';
        t.textContent = ': ' + items[k - 1].querySelector('.dxsg-step__text').textContent;
        status.appendChild(t);
      }
    }
    function run() {
      var t = wait(now);
      bar.classList.remove('is-run'); void bar.offsetWidth;
      bar.style.setProperty('--sg-t', t + 'ms'); bar.classList.add('is-run');
      timer = setTimeout(function () {
        timer = null;
        if (now < n) { show(now + 1); run(); label(); return; }
        done = true; stop(); show(n);
      }, t);
    }
    function stop() {
      if (timer) { clearTimeout(timer); timer = null; }
      bar.classList.remove('is-run');
      label();
    }
    function label() { play.textContent = timer ? txt('pause', null, 'Pause') : done ? txt('replay', null, 'Replay') : txt('play', null, 'Play'); }
    function start(byReader) {
      if (timer) return;
      mine = !!byReader;
      if (byReader) { held = false; tell(); }
      if (now === n && (done || byReader)) { done = false; show(1); }
      done = false;
      run();
      label();
    }
    function tell() { told = true; status.setAttribute('aria-live', 'polite'); }
    function hold() { held = true; done = false; tell(); stop(); }
    function auto() {
      if (!reduce && onScreen && !held && !done && !document.hidden) start(false);
      else if (timer && (!onScreen || document.hidden || (reduce && !mine))) stop();
    }
    autos.push(auto);
    play.addEventListener('click', function () { if (timer) hold(); else start(true); });
    prev.addEventListener('click', function () { hold(); if (now > 1) show(now - 1); });
    next.addEventListener('click', function () { hold(); show(now < n ? now + 1 : 1); });
    document.addEventListener('visibilitychange', auto);
    status.setAttribute('aria-live', 'off');
    show(1);
    if ('IntersectionObserver' in window && list) {
      new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; auto(); }, { threshold: 0.5 }).observe(list);
    }
  }

  /* printing shows every step (CSS) and opens every question */
  window.addEventListener('beforeprint', function () {
    var d = root.querySelectorAll('.dxsg-faq details');
    for (var i = 0; i < d.length; i++) d[i].open = true;
  });

  /* 3. join form */
  var box = document.getElementById('dxsg-form');
  if (!box) return;
  var $ = function (id) { return document.getElementById(id); };
  var f = { name: $('sg-name'), email: $('sg-email'), lang: $('sg-lang'), help: $('sg-help'), adult: $('sg-adult'), rules: $('sg-rules'), emails: $('sg-emails'), trap: $('sg-website') };
  var roleSet = $('sg-role'), errs = $('dxsg-errs'), fields = box.querySelector('.dxsg-fields'), doneBox = $('dxsg-done'), btn = $('sg-submit'), count = $('sg-help-c');
  var started = Date.now(), busy = false, lastEmail = '';
  var open = box.getAttribute('data-open') === 'true', api = box.getAttribute('data-api'), wa = box.getAttribute('data-wa');

  function counter() { count.textContent = txt('count', { n: f.help.value.length }); }
  f.help.addEventListener('input', counter); counter();

  /* Enter in a one-line field acts like pressing the button */
  box.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox' && e.target.type !== 'radio') { e.preventDefault(); submit(); }
  });
  btn.addEventListener('click', submit);

  function role() { var r = box.querySelector('input[name="sg_role"]:checked'); return r ? r.value : ''; }
  function mark(el, bad) { if (el) el.setAttribute('aria-invalid', bad ? 'true' : 'false'); }

  function check() {
    var list = [];
    var name = f.name.value.trim(), email = f.email.value.trim();
    var add = function (el, key, focusEl) { list.push({ el: focusEl || el, msg: txt(key) }); mark(el, true); };
    [f.name, f.email, f.adult, f.rules, f.emails, f.help].forEach(function (el) { mark(el, false); });
    roleSet.removeAttribute('aria-invalid');
    if (!name) add(f.name, 'errName');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) add(f.email, 'errEmail');
    if (!role()) { list.push({ el: box.querySelector('input[name="sg_role"]'), msg: txt('errRole') }); roleSet.setAttribute('aria-invalid', 'true'); }
    if (f.help.value.length > 300) add(f.help, 'errHelp');
    if (!f.adult.checked) add(f.adult, 'errAdult');
    if (!f.rules.checked) add(f.rules, 'errRules');
    if (!f.emails.checked) add(f.emails, 'errEmails');
    return list;
  }

  function showErrs(list) {
    errs.innerHTML = '';
    var h = document.createElement('p'); h.className = 'dxsg-errs__h'; h.textContent = txt('errTitle'); errs.appendChild(h);
    var ul = document.createElement('ul');
    list.forEach(function (it) {
      var li = document.createElement('li'), a = document.createElement('a');
      a.href = '#' + (it.el.id || 'sg-role'); a.textContent = it.msg;
      a.addEventListener('click', function (e) { e.preventDefault(); it.el.focus(); });
      li.appendChild(a); ul.appendChild(li);
    });
    errs.appendChild(ul);
    errs.hidden = false;
    errs.focus();
  }

  function panel(title, body, extra) {
    doneBox.innerHTML = '';
    var h = document.createElement('h3'); h.textContent = title; doneBox.appendChild(h);
    var p = document.createElement('p'); p.textContent = body; doneBox.appendChild(p);
    if (extra) doneBox.appendChild(extra);
    fields.hidden = true; errs.hidden = true; doneBox.hidden = false;
    doneBox.focus();
  }

  function waLink() {
    var a = document.createElement('a');
    a.className = 'dxsg-btn dxsg-btn--navy'; a.href = wa; a.target = '_blank'; a.rel = 'noopener';
    a.textContent = txt('wa', null, 'Message us on WhatsApp');
    return a;
  }

  function submit() {
    if (busy) return;
    var list = check();
    if (list.length) { showErrs(list); return; }
    errs.hidden = true;
    if (!open) {
      var wrap = document.createElement('div'); wrap.className = 'dxsg-done__acts';
      wrap.appendChild(waLink());
      panel(txt('closedTitle'), txt('closedText'), wrap);
      return;
    }
    send(false);
  }

  function send(isResend) {
    busy = true;
    btn.textContent = txt('sending'); btn.setAttribute('aria-disabled', 'true');
    var email = isResend ? lastEmail : f.email.value.trim();
    var body = {
      preferred_name: f.name.value.trim(), email: email, joining_as: role(), adult: f.adult.checked,
      language: f.lang.value, help_note: f.help.value.trim(),
      consent_rules: box.getAttribute('data-rules'), consent_emails: box.getAttribute('data-emails'),
      website: f.trap.value, started_ms: Date.now() - started
    };
    fetch(api, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { s: r.status, j: j }; }); })
      .then(function (res) {
        busy = false; btn.textContent = txt('submit'); btn.removeAttribute('aria-disabled');
        if (res.s === 200 && res.j && res.j.ok) {
          lastEmail = email;
          if (isResend) { var note = doneBox.querySelector('.dxsg-done__note'); if (note) note.textContent = txt('resent'); return; }
          var acts = document.createElement('div'); acts.className = 'dxsg-done__acts';
          var again = document.createElement('button'); again.type = 'button'; again.className = 'dxsg-btn dxsg-btn--outline'; again.textContent = txt('resend', null, 'Send the email again');
          again.addEventListener('click', function () { send(true); });
          var edit = document.createElement('button'); edit.type = 'button'; edit.className = 'dxsg-btn dxsg-btn--outline'; edit.textContent = txt('change', null, 'Change my email');
          edit.addEventListener('click', function () { doneBox.hidden = true; fields.hidden = false; f.email.focus(); });
          var note = document.createElement('p'); note.className = 'dxsg-done__note'; note.setAttribute('aria-live', 'polite');
          acts.appendChild(again); acts.appendChild(edit);
          var holder = document.createElement('div'); holder.appendChild(acts); holder.appendChild(note);
          panel(txt('doneTitle'), txt('doneText', { email: email }), holder);
          return;
        }
        if (res.s === 400 && res.j && res.j.field) {
          var map = { preferred_name: [f.name, 'errName'], email: [f.email, 'errEmail'], joining_as: [box.querySelector('input[name="sg_role"]'), 'errRole'], adult: [f.adult, 'errAdult'], consent_rules: [f.rules, 'errRules'], consent_emails: [f.emails, 'errEmails'], help_note: [f.help, 'errHelp'] };
          var hit = map[res.j.field];
          if (hit) { showErrs([{ el: hit[0], msg: txt(hit[1]) }]); return; }
        }
        fail(res.s === 429 ? 'busy' : 'failed');
      })
      .catch(function () { busy = false; btn.textContent = txt('submit'); btn.removeAttribute('aria-disabled'); fail('failed'); });
  }

  function fail(key) {
    if (!doneBox.hidden) { var note = doneBox.querySelector('.dxsg-done__note'); if (note) { note.textContent = txt(key); return; } }
    errs.innerHTML = '';
    var p = document.createElement('p'); p.className = 'dxsg-errs__h'; p.textContent = txt(key); errs.appendChild(p);
    errs.hidden = false; errs.focus();
  }
})();
